export default __webpack_public_path__ + "static/logo-cci-8220f260e4d4f46aa14b9f5716b361d2.jpg";